import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  encounters as encounters_ravenland,
  terrainList as terrain_ravenland,
} from "../../../src/json/encounter_data_gamemasters_guide";
import {
  encounters as encounters_bitterreach,
  terrainList as terrain_bitterreach,
} from "../../../src/json/encounter_data_bitter_reach";
import background2 from "../../../src/assets/forbidden-lands-map-hex-overly-no-text-1920-background.jpg";
import { hexData } from "../../../src/js/hexData";
import { useAuth } from "../../../src/contexts/AuthContext";
import { ref, getBlob } from "firebase/storage";
import { storage } from "../../../src/firebase/config";
import analytics from "../../../src/analytics/posthog";

const protectedMapDefinitions = {
  forbiddenLands: {
    label: "Forbidden Lands Map Hex Overlax (6000 x 4346)",
    storagePath:
      "protected-maps/Forbidden Lands Map Complete Basic 6000w.jpg",
  },
  forbiddenLandsKin: {
    label: "Forbidden Lands Kin Map Hex Overlax (6000 x 4346)",
    storagePath:
      "protected-maps/Forbidden Lands Map Complete Basic 6000w - kin map.jpg",
  },
  bitterReachHexOverlay: {
    label: "Bitter Reach Map Hex Overlay (6236 x 4503)",
    storagePath: "protected-maps/bitter-reach-map-hex-overlays.jpg",
  },
  bitterReach: {
    label: "Bitter Reach Map Basic (6236 x 4503)",
    storagePath: "protected-maps/bitter-reach-map.jpg",
  },
};

// let backgroundImages = [{background1},{background2},{background3},{background4}]
const hexLetters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
];
let hexNumbers = [...Array(52).keys()];

// function getRandomIndexFromList(inputList) {
//   return Math.floor(Math.random() * inputList.length);
// }

function getTerrainNew(name, terrain) {
  let z = terrain.filter((x) => x.name === name);
  return z[0] ? z[0].freq : 0;
}

class HexTraveller extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      encountersData: null,
      selectedTerrain: "",
      terrain: "",
      encounterName: null,
      encounter: null,
      backgroundImage: null,
      ignoreNoEncounterResults: false,
      selectedCampaign: "ravenland",
      hexLabels: null,
      input: "g18",
      hexData: null,
      x: 0,
      y: 0,
    };
  }
  buildHexLabels = () => {
    hexNumbers.shift();
    let temp = [];
    for (const x of hexLetters) {
      for (const y of hexNumbers) {
        temp.push(x + y);
      }
    }
    this.setState({ hexLabels: temp });
  };
  randomEncounterMonster = (encounterListNew) => {
    let r = Math.floor(Math.random() * encounterListNew.length);
    return encounterListNew[r] ? encounterListNew[r].name : null;
  };
  buildTerrainList = () => {
    //NOTE: in future we may combine all terrain lists into master of unique terrains
    if (this.state.selectedCampaign === "bitter reach") {
      return terrain_bitterreach;
    }
    return terrain_ravenland;
  };
  createSelectItems = () => {
    let items = [];
    let terrainList = this.buildTerrainList();
    items.push(<option key={-1} value={-1}></option>);
    terrainList.forEach(function (item, index) {
      items.push(
        <option key={index} value={item}>
          {item.toUpperCase()}
        </option>,
      );
    });
    return items;
  };

  componentDidMount() {
    this.buildHexLabels();

    this.setState({ backgroundImage: background2 });
    this.setState({ encountersData: this.getCampaignData() });
  }
  handleChangeNoEncounter = (e) => {
    this.setState({ ignoreNoEncounterResults: e.target.checked });
  };
  getCampaignData = (name) => {
    switch (name) {
      case "bitter reach":
        return encounters_bitterreach;
      default:
        return encounters_ravenland;
    }
  };
  handleChangeCampaign = (e) => {
    let selectedCampaign = e.target.value;
    this.setState({ selectedCampaign: e.target.value }, this.createSelectItems);
    this.setState({ encountersData: this.getCampaignData(selectedCampaign) });
  };
  /*
Create list of objects that have encounter names. There are as many rows with same encounter name
as their designated frequency.
NOTE: convert to binary tree search - https://stackoverflow.com/questions/16927299/coding-random-encounter
[
  {name: "bloodmist"}
  {name: "bloodmist"}
  {name: "death from above"}
  {name: "death from above"}
  {name: "the harpies' feast"}
  {name: "the harpies' feast"}
]
 */
  buildEncounterList = (terrain, ignoreNoEncounters) => {
    if (!terrain) {
      return;
    }
    let encounters = this.state.encountersData;
    let encounterList = [];
    for (let name in encounters) {
      if (ignoreNoEncounters && name === "no encounter") {
        continue;
      }
      let frequency = getTerrainNew(terrain, encounters[name].terrain);
      for (let i = 0; i < frequency; i++) {
        encounterList.push({ name: name });
      }
    }
    return encounterList;
  };

  changeBackground = (e) => {
    e.target.style.background = "red";
  };
  mouseLeave = (e) => {
    e.target.style.background = "green";
  };

  handleChange = (e) => {
    this.setState({ input: e.target.value });
  };
  handleClick = (e) => {
    // let newImageObj = backgroundImages[getRandomIndexFromList(backgroundImages)];
    // let newImage = Object.values(newImageObj)[0];
    let input = this.state.input;
    if (input) {
      const d = hexData.filter((x) => x["name"] === input.toUpperCase());
      this.setState({ hexData: d[0] });
    }
  };
  selectRegion = (x, y) => {
    console.log("SELECT REGION");
  };
  render() {
    const { currentUser, mapUrls: rawMapUrls, mapUrlsLoading, mapUrlsError } = this.props;
    const isLocked = !currentUser;
    const mapUrls = rawMapUrls || {};
    const returnTo = "/forbidden-lands-campaign-maps";
    const loginHref = `/login?returnTo=${encodeURIComponent(returnTo)}`;
    const signupHref = `/signup?returnTo=${encodeURIComponent(returnTo)}`;

    const renderMapLink = (key, label, mapUrl) => {
      if (isLocked) {
        return (
          <a href={loginHref} target="_blank" rel="noopener noreferrer">
            {label}
          </a>
        );
      }
      if (mapUrlsLoading) {
        return <span style={{ color: "#888" }}>{label} — loading…</span>;
      }
      if (mapUrlsError || !mapUrl) {
        return (
          <span style={{ color: "#c00" }}>
            {label} — unavailable, please refresh to retry
          </span>
        );
      }
      return (
        <a
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => analytics.capture("campaign_map_opened", { map: key })}
        >
          {label}
        </a>
      );
    };

    const backgroundStyle = {
      backgroundImage: `url(${this.state.backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      width: "100vw",
      height: "2000px",
    };

    const contentStyle = {
      backgroundColor: "#ffffff",
      padding: 20,
      opacity: isLocked ? 0.42 : 0.7,
      width: "50vw",
      margin: "0 auto",
      pointerEvents: isLocked ? "none" : "auto",
      filter: isLocked ? "blur(1.5px)" : "none",
    };

    const overlayStyle = {
      position: "fixed",
      inset: 0,
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      backgroundColor: "rgba(8, 11, 17, 0.62)",
      backdropFilter: "blur(4px)",
    };

    const overlayCardStyle = {
      width: "100%",
      maxWidth: "560px",
      borderRadius: "20px",
      backgroundColor: "rgba(255, 255, 255, 0.96)",
      boxShadow: "0 24px 80px rgba(0, 0, 0, 0.35)",
      border: "1px solid rgba(0, 0, 0, 0.08)",
      padding: "28px 30px",
      textAlign: "center",
      position: "relative",
    };

    const overlayButtonRowStyle = {
      display: "flex",
      gap: "12px",
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: "22px",
    };

    const overlayLinkStyle = {
      display: "inline-block",
      padding: "12px 18px",
      borderRadius: "999px",
      textDecoration: "none",
      fontWeight: 700,
      minWidth: "160px",
    };

    const primaryLinkStyle = {
      ...overlayLinkStyle,
      backgroundColor: "#111827",
      color: "#ffffff",
    };

    const secondaryLinkStyle = {
      ...overlayLinkStyle,
      backgroundColor: "#ffffff",
      color: "#111827",
      border: "1px solid rgba(17, 24, 39, 0.22)",
    };

    const overlayCloseIconStyle = {
      position: "absolute",
      top: "10px",
      right: "12px",
      border: "none",
      background: "transparent",
      fontSize: "1.4rem",
      lineHeight: 1,
      color: "#64748b",
      cursor: "pointer",
    };

    const overlayCloseButtonStyle = {
      marginTop: "12px",
      padding: "10px 16px",
      borderRadius: "999px",
      border: "1px solid rgba(17, 24, 39, 0.22)",
      backgroundColor: "#f8fafc",
      color: "#111827",
      fontWeight: 600,
      cursor: "pointer",
    };
    return (
      <div style={{ ...backgroundStyle, position: "relative" }}>
        <div style={contentStyle} aria-hidden={isLocked}>
          <center>
            <h2>Forbidden Lands Campaign Maps with Hex Overlay</h2>
            <br />
            {renderMapLink("forbiddenLands", protectedMapDefinitions.forbiddenLands.label, mapUrls.forbiddenLands)}
            <br />
            <br />
            {renderMapLink("forbiddenLandsKin", protectedMapDefinitions.forbiddenLandsKin.label, mapUrls.forbiddenLandsKin)}
            <br />
            <br />
            {renderMapLink("bitterReachHexOverlay", protectedMapDefinitions.bitterReachHexOverlay.label, mapUrls.bitterReachHexOverlay)}
            <br />
            <br />
            {renderMapLink("bitterReach", protectedMapDefinitions.bitterReach.label, mapUrls.bitterReach)}
            <br />
            <br />
          </center>
        </div>
        {isLocked && (
          <div
            style={overlayStyle}
            role="dialog"
            aria-modal="true"
            aria-labelledby="campaign-maps-login-title"
          >
            <div style={overlayCardStyle}>
              <button
                type="button"
                onClick={this.props.onCloseOverlay}
                aria-label="Close and go back"
                style={overlayCloseIconStyle}
              >
                ×
              </button>
              <h2
                id="campaign-maps-login-title"
                style={{ marginTop: 0, marginBottom: "14px" }}
              >
                Create A Free Account!
              </h2>
              {/* <p style={{ marginBottom: '10px', fontSize: '1.05rem', lineHeight: 1.55 }}>
                You can create a free account in moments, thank you!
              </p> */}
              <p
                style={{ marginBottom: 0, color: "#374151", lineHeight: 1.55 }}
              >
                We don't sell or share it of course, and it helps us keep the
                lights on and the content coming. Thank you for your support!
              </p>
              <div style={overlayButtonRowStyle}>
                <Link to={loginHref} style={primaryLinkStyle}>
                  Log in
                </Link>
                <Link to={signupHref} style={secondaryLinkStyle}>
                  Create free account
                </Link>
              </div>
              <button
                type="button"
                onClick={this.props.onCloseOverlay}
                style={overlayCloseButtonStyle}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const CampaignMaps = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [mapUrls, setMapUrls] = useState({});
  const [mapUrlsLoading, setMapUrlsLoading] = useState(false);
  const [mapUrlsError, setMapUrlsError] = useState(null);

  const handleOverlayClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/");
  };

  useEffect(() => {
    let isActive = true;
    let createdObjectUrls = [];

    const loadMapUrls = async () => {
      if (!currentUser) {
        setMapUrls({});
        setMapUrlsLoading(false);
        setMapUrlsError(null);
        return;
      }

      setMapUrlsLoading(true);
      setMapUrlsError(null);

      try {
        const entries = await Promise.all(
          Object.entries(protectedMapDefinitions).map(
            async ([key, definition]) => {
              const blob = await getBlob(ref(storage, definition.storagePath));
              const objectUrl = URL.createObjectURL(blob);
              return [key, objectUrl];
            },
          ),
        );

        createdObjectUrls = entries.map(([, url]) => url);

        if (isActive) {
          setMapUrls(Object.fromEntries(entries));
          setMapUrlsLoading(false);
        } else {
          createdObjectUrls.forEach((url) => URL.revokeObjectURL(url));
        }
      } catch (error) {
        console.error("Failed to load protected map URLs:", error);
        if (isActive) {
          setMapUrls({});
          setMapUrlsLoading(false);
          setMapUrlsError("Map links couldn't be loaded — please refresh to try again.");
        }
      }
    };

    loadMapUrls();

    return () => {
      isActive = false;
      createdObjectUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [currentUser]);

  return (
    <HexTraveller
      currentUser={currentUser}
      mapUrls={mapUrls}
      mapUrlsLoading={mapUrlsLoading}
      mapUrlsError={mapUrlsError}
      onCloseOverlay={handleOverlayClose}
    />
  );
};

export default CampaignMaps;
